import { createContext, useEffect, useMemo, useState } from "react";
import { useWeb3React } from "@web3-react/core";

import { injected, walletconnect } from "./connectors";

import { sendConnectWalletEvent } from "../gtm";

const { REACT_APP_ENV } = process.env;

export const W3Context = createContext({
  active: false,
  account: "",
  library: null,
  connector: null,
});

export const W3Provider = ({ children }) => {
  const { active, account, library, connector, activate, deactivate } =
    useWeb3React();
  const [didTry, setDidTry] = useState(false);
  const W3CValue = useMemo(
    () => ({
      active,
      account,
      library,
      connector,
      connectInjected,
      connectWalletConnect,
      disconnect,
      checkNetwork,
    }),
    [active, account, library, connector, activate, deactivate]
  );

  function checkNetwork() {
    if (typeof window.ethereum !== "undefined") {
      if (
        window.ethereum.chainId !== null &&
        window.ethereum.chainId !== "0x89" &&
        window.ethereum.chainId !== "0x13881"
      ) {
        window.alert(
          "You are on the wrong network, please switch to polygon network."
        );
      } else {
        if (!active && !didTry) {
          connectInjected();
          setDidTry(true);
        }
      }
    }
    if (typeof connector !== "undefined") {
      connector.on("Web3ReactUpdate", (_update) => {
        if ("chainId" in _update) {
          if (REACT_APP_ENV === "staging") {
            if (
              _update["chainId"] !== "80001" &&
              _update["chainId"] !== "0x13881"
            ) {
              window.alert(
                "You are on the wrong network, please switch to polygon network."
              );
            }
          } else {
            if (_update["chainId"] !== "137" && _update["chainId"] !== "0x89") {
              window.alert(
                "You are on the wrong network, please switch to polygon network."
              );
            }
          }
        }
      });
    }
  }

  useEffect(() => {
    checkNetwork();
  });

  useEffect(() => {
    if (active) {
      sendConnectWalletEvent("Confirmation");
    }
  }, [active]);

  async function connectInjected() {
    try {
      sendConnectWalletEvent("Intention");
      await activate(injected);
    } catch (ex) {
      console.log(ex);
    }
  }

  async function connectWalletConnect() {
    try {
      sendConnectWalletEvent("Intention");
      await activate(walletconnect);
    } catch (ex) {
      console.log(ex);
    }
  }

  async function disconnect() {
    try {
      deactivate();
    } catch (ex) {
      console.log(ex);
    }
  }

  return <W3Context.Provider value={W3CValue}>{children}</W3Context.Provider>;
};
